module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/3@2x_9b386c7ad5291b5beb485e580e959192.png";